import { default as _91_46_46_46slug_93RZqYI9visnMeta } from "/builds/common/airbaltic-com/bt-frontend-nuxt/pages/[...slug].vue?macro=true";
import { default as book_45flightLOTrmbhKVFMeta } from "/builds/common/airbaltic-com/bt-frontend-nuxt/pages/book-flight.vue?macro=true";
import { default as _91slug_9329ECDds6kRMeta } from "/builds/common/airbaltic-com/bt-frontend-nuxt/pages/campaign/[slug].vue?macro=true";
import { default as check_45inEkIu1lwQr9Meta } from "/builds/common/airbaltic-com/bt-frontend-nuxt/pages/check-in.vue?macro=true";
import { default as collapsibletoh2r9EGLUMeta } from "/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/collapsible.vue?macro=true";
import { default as drawerYwRx9qS9UcMeta } from "/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/drawer.vue?macro=true";
import { default as input_45baseuPwDfNVod9Meta } from "/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/input-base.vue?macro=true";
import { default as input_45inlineYNJqqFaB84Meta } from "/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/input-inline.vue?macro=true";
import { default as indexTLhFQU3CkjMeta } from "/builds/common/airbaltic-com/bt-frontend-nuxt/pages/index.vue?macro=true";
import { default as manage_45my_45bookingcBDqHirJEvMeta } from "/builds/common/airbaltic-com/bt-frontend-nuxt/pages/manage-my-booking.vue?macro=true";
import { default as self_45service_45portalEMseZcIYq0Meta } from "/builds/common/airbaltic-com/bt-frontend-nuxt/pages/self-service-portal.vue?macro=true";
import { default as component_45stubRZ7YypkiNzMeta } from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/nuxt/dist/pages/runtime/component-stub?macro=true";
import { default as component_45stubRZ7YypkiNz } from "/builds/common/airbaltic-com/bt-frontend-nuxt/node_modules/nuxt/dist/pages/runtime/component-stub";
export default [
  {
    name: _91_46_46_46slug_93RZqYI9visnMeta?.name ?? "slug___en",
    path: _91_46_46_46slug_93RZqYI9visnMeta?.path ?? "/en/:slug(.*)*",
    meta: _91_46_46_46slug_93RZqYI9visnMeta || {},
    alias: _91_46_46_46slug_93RZqYI9visnMeta?.alias || [],
    redirect: _91_46_46_46slug_93RZqYI9visnMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93RZqYI9visnMeta?.name ?? "slug___lv",
    path: _91_46_46_46slug_93RZqYI9visnMeta?.path ?? "/lv/:slug(.*)*",
    meta: _91_46_46_46slug_93RZqYI9visnMeta || {},
    alias: _91_46_46_46slug_93RZqYI9visnMeta?.alias || [],
    redirect: _91_46_46_46slug_93RZqYI9visnMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93RZqYI9visnMeta?.name ?? "slug___lt",
    path: _91_46_46_46slug_93RZqYI9visnMeta?.path ?? "/lt/:slug(.*)*",
    meta: _91_46_46_46slug_93RZqYI9visnMeta || {},
    alias: _91_46_46_46slug_93RZqYI9visnMeta?.alias || [],
    redirect: _91_46_46_46slug_93RZqYI9visnMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93RZqYI9visnMeta?.name ?? "slug___de",
    path: _91_46_46_46slug_93RZqYI9visnMeta?.path ?? "/de/:slug(.*)*",
    meta: _91_46_46_46slug_93RZqYI9visnMeta || {},
    alias: _91_46_46_46slug_93RZqYI9visnMeta?.alias || [],
    redirect: _91_46_46_46slug_93RZqYI9visnMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93RZqYI9visnMeta?.name ?? "slug___et",
    path: _91_46_46_46slug_93RZqYI9visnMeta?.path ?? "/et/:slug(.*)*",
    meta: _91_46_46_46slug_93RZqYI9visnMeta || {},
    alias: _91_46_46_46slug_93RZqYI9visnMeta?.alias || [],
    redirect: _91_46_46_46slug_93RZqYI9visnMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93RZqYI9visnMeta?.name ?? "slug___fi",
    path: _91_46_46_46slug_93RZqYI9visnMeta?.path ?? "/fi/:slug(.*)*",
    meta: _91_46_46_46slug_93RZqYI9visnMeta || {},
    alias: _91_46_46_46slug_93RZqYI9visnMeta?.alias || [],
    redirect: _91_46_46_46slug_93RZqYI9visnMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93RZqYI9visnMeta?.name ?? "slug___ru",
    path: _91_46_46_46slug_93RZqYI9visnMeta?.path ?? "/ru/:slug(.*)*",
    meta: _91_46_46_46slug_93RZqYI9visnMeta || {},
    alias: _91_46_46_46slug_93RZqYI9visnMeta?.alias || [],
    redirect: _91_46_46_46slug_93RZqYI9visnMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93RZqYI9visnMeta?.name ?? "slug___uk",
    path: _91_46_46_46slug_93RZqYI9visnMeta?.path ?? "/uk/:slug(.*)*",
    meta: _91_46_46_46slug_93RZqYI9visnMeta || {},
    alias: _91_46_46_46slug_93RZqYI9visnMeta?.alias || [],
    redirect: _91_46_46_46slug_93RZqYI9visnMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: book_45flightLOTrmbhKVFMeta?.name ?? "book-flight___en",
    path: book_45flightLOTrmbhKVFMeta?.path ?? "/en/book-flight",
    meta: book_45flightLOTrmbhKVFMeta || {},
    alias: book_45flightLOTrmbhKVFMeta?.alias || [],
    redirect: book_45flightLOTrmbhKVFMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/book-flight.vue").then(m => m.default || m)
  },
  {
    name: book_45flightLOTrmbhKVFMeta?.name ?? "book-flight___lv",
    path: book_45flightLOTrmbhKVFMeta?.path ?? "/lv/rezervet-biletes",
    meta: book_45flightLOTrmbhKVFMeta || {},
    alias: book_45flightLOTrmbhKVFMeta?.alias || [],
    redirect: book_45flightLOTrmbhKVFMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/book-flight.vue").then(m => m.default || m)
  },
  {
    name: book_45flightLOTrmbhKVFMeta?.name ?? "book-flight___lt",
    path: book_45flightLOTrmbhKVFMeta?.path ?? "/lt/uzsakyti-skrydzius",
    meta: book_45flightLOTrmbhKVFMeta || {},
    alias: book_45flightLOTrmbhKVFMeta?.alias || [],
    redirect: book_45flightLOTrmbhKVFMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/book-flight.vue").then(m => m.default || m)
  },
  {
    name: book_45flightLOTrmbhKVFMeta?.name ?? "book-flight___de",
    path: book_45flightLOTrmbhKVFMeta?.path ?? "/de/fluge-buchen",
    meta: book_45flightLOTrmbhKVFMeta || {},
    alias: book_45flightLOTrmbhKVFMeta?.alias || [],
    redirect: book_45flightLOTrmbhKVFMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/book-flight.vue").then(m => m.default || m)
  },
  {
    name: book_45flightLOTrmbhKVFMeta?.name ?? "book-flight___et",
    path: book_45flightLOTrmbhKVFMeta?.path ?? "/et/broneerige-lend",
    meta: book_45flightLOTrmbhKVFMeta || {},
    alias: book_45flightLOTrmbhKVFMeta?.alias || [],
    redirect: book_45flightLOTrmbhKVFMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/book-flight.vue").then(m => m.default || m)
  },
  {
    name: book_45flightLOTrmbhKVFMeta?.name ?? "book-flight___fi",
    path: book_45flightLOTrmbhKVFMeta?.path ?? "/fi/varaa-lennot",
    meta: book_45flightLOTrmbhKVFMeta || {},
    alias: book_45flightLOTrmbhKVFMeta?.alias || [],
    redirect: book_45flightLOTrmbhKVFMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/book-flight.vue").then(m => m.default || m)
  },
  {
    name: book_45flightLOTrmbhKVFMeta?.name ?? "book-flight___ru",
    path: book_45flightLOTrmbhKVFMeta?.path ?? "/ru/kupit-aviabilety",
    meta: book_45flightLOTrmbhKVFMeta || {},
    alias: book_45flightLOTrmbhKVFMeta?.alias || [],
    redirect: book_45flightLOTrmbhKVFMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/book-flight.vue").then(m => m.default || m)
  },
  {
    name: book_45flightLOTrmbhKVFMeta?.name ?? "book-flight___uk",
    path: book_45flightLOTrmbhKVFMeta?.path ?? "/uk/bronyujte-aviakvitki",
    meta: book_45flightLOTrmbhKVFMeta || {},
    alias: book_45flightLOTrmbhKVFMeta?.alias || [],
    redirect: book_45flightLOTrmbhKVFMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/book-flight.vue").then(m => m.default || m)
  },
  {
    name: _91slug_9329ECDds6kRMeta?.name ?? "campaign-slug___en",
    path: _91slug_9329ECDds6kRMeta?.path ?? "/en/campaign/:slug()",
    meta: _91slug_9329ECDds6kRMeta || {},
    alias: _91slug_9329ECDds6kRMeta?.alias || [],
    redirect: _91slug_9329ECDds6kRMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/campaign/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_9329ECDds6kRMeta?.name ?? "campaign-slug___lv",
    path: _91slug_9329ECDds6kRMeta?.path ?? "/lv/campaign/:slug()",
    meta: _91slug_9329ECDds6kRMeta || {},
    alias: _91slug_9329ECDds6kRMeta?.alias || [],
    redirect: _91slug_9329ECDds6kRMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/campaign/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_9329ECDds6kRMeta?.name ?? "campaign-slug___lt",
    path: _91slug_9329ECDds6kRMeta?.path ?? "/lt/campaign/:slug()",
    meta: _91slug_9329ECDds6kRMeta || {},
    alias: _91slug_9329ECDds6kRMeta?.alias || [],
    redirect: _91slug_9329ECDds6kRMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/campaign/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_9329ECDds6kRMeta?.name ?? "campaign-slug___de",
    path: _91slug_9329ECDds6kRMeta?.path ?? "/de/campaign/:slug()",
    meta: _91slug_9329ECDds6kRMeta || {},
    alias: _91slug_9329ECDds6kRMeta?.alias || [],
    redirect: _91slug_9329ECDds6kRMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/campaign/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_9329ECDds6kRMeta?.name ?? "campaign-slug___et",
    path: _91slug_9329ECDds6kRMeta?.path ?? "/et/campaign/:slug()",
    meta: _91slug_9329ECDds6kRMeta || {},
    alias: _91slug_9329ECDds6kRMeta?.alias || [],
    redirect: _91slug_9329ECDds6kRMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/campaign/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_9329ECDds6kRMeta?.name ?? "campaign-slug___fi",
    path: _91slug_9329ECDds6kRMeta?.path ?? "/fi/campaign/:slug()",
    meta: _91slug_9329ECDds6kRMeta || {},
    alias: _91slug_9329ECDds6kRMeta?.alias || [],
    redirect: _91slug_9329ECDds6kRMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/campaign/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_9329ECDds6kRMeta?.name ?? "campaign-slug___ru",
    path: _91slug_9329ECDds6kRMeta?.path ?? "/ru/campaign/:slug()",
    meta: _91slug_9329ECDds6kRMeta || {},
    alias: _91slug_9329ECDds6kRMeta?.alias || [],
    redirect: _91slug_9329ECDds6kRMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/campaign/[slug].vue").then(m => m.default || m)
  },
  {
    name: _91slug_9329ECDds6kRMeta?.name ?? "campaign-slug___uk",
    path: _91slug_9329ECDds6kRMeta?.path ?? "/uk/campaign/:slug()",
    meta: _91slug_9329ECDds6kRMeta || {},
    alias: _91slug_9329ECDds6kRMeta?.alias || [],
    redirect: _91slug_9329ECDds6kRMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/campaign/[slug].vue").then(m => m.default || m)
  },
  {
    name: check_45inEkIu1lwQr9Meta?.name ?? "check-in___en",
    path: check_45inEkIu1lwQr9Meta?.path ?? "/en/check-in",
    meta: check_45inEkIu1lwQr9Meta || {},
    alias: check_45inEkIu1lwQr9Meta?.alias || [],
    redirect: check_45inEkIu1lwQr9Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/check-in.vue").then(m => m.default || m)
  },
  {
    name: check_45inEkIu1lwQr9Meta?.name ?? "check-in___lv",
    path: check_45inEkIu1lwQr9Meta?.path ?? "/lv/registresanas-lidojumam",
    meta: check_45inEkIu1lwQr9Meta || {},
    alias: check_45inEkIu1lwQr9Meta?.alias || [],
    redirect: check_45inEkIu1lwQr9Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/check-in.vue").then(m => m.default || m)
  },
  {
    name: check_45inEkIu1lwQr9Meta?.name ?? "check-in___lt",
    path: check_45inEkIu1lwQr9Meta?.path ?? "/lt/registracija-skrydziui",
    meta: check_45inEkIu1lwQr9Meta || {},
    alias: check_45inEkIu1lwQr9Meta?.alias || [],
    redirect: check_45inEkIu1lwQr9Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/check-in.vue").then(m => m.default || m)
  },
  {
    name: check_45inEkIu1lwQr9Meta?.name ?? "check-in___de",
    path: check_45inEkIu1lwQr9Meta?.path ?? "/de/online-check-in",
    meta: check_45inEkIu1lwQr9Meta || {},
    alias: check_45inEkIu1lwQr9Meta?.alias || [],
    redirect: check_45inEkIu1lwQr9Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/check-in.vue").then(m => m.default || m)
  },
  {
    name: check_45inEkIu1lwQr9Meta?.name ?? "check-in___et",
    path: check_45inEkIu1lwQr9Meta?.path ?? "/et/lennule-registreerimine",
    meta: check_45inEkIu1lwQr9Meta || {},
    alias: check_45inEkIu1lwQr9Meta?.alias || [],
    redirect: check_45inEkIu1lwQr9Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/check-in.vue").then(m => m.default || m)
  },
  {
    name: check_45inEkIu1lwQr9Meta?.name ?? "check-in___fi",
    path: check_45inEkIu1lwQr9Meta?.path ?? "/fi/lahtoselvitys",
    meta: check_45inEkIu1lwQr9Meta || {},
    alias: check_45inEkIu1lwQr9Meta?.alias || [],
    redirect: check_45inEkIu1lwQr9Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/check-in.vue").then(m => m.default || m)
  },
  {
    name: check_45inEkIu1lwQr9Meta?.name ?? "check-in___ru",
    path: check_45inEkIu1lwQr9Meta?.path ?? "/ru/registraciya-na-rejs",
    meta: check_45inEkIu1lwQr9Meta || {},
    alias: check_45inEkIu1lwQr9Meta?.alias || [],
    redirect: check_45inEkIu1lwQr9Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/check-in.vue").then(m => m.default || m)
  },
  {
    name: check_45inEkIu1lwQr9Meta?.name ?? "check-in___uk",
    path: check_45inEkIu1lwQr9Meta?.path ?? "/uk/online-reiestratsiia",
    meta: check_45inEkIu1lwQr9Meta || {},
    alias: check_45inEkIu1lwQr9Meta?.alias || [],
    redirect: check_45inEkIu1lwQr9Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/check-in.vue").then(m => m.default || m)
  },
  {
    name: collapsibletoh2r9EGLUMeta?.name ?? "component-collapsible___en",
    path: collapsibletoh2r9EGLUMeta?.path ?? "/en/component/collapsible",
    meta: collapsibletoh2r9EGLUMeta || {},
    alias: collapsibletoh2r9EGLUMeta?.alias || [],
    redirect: collapsibletoh2r9EGLUMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/collapsible.vue").then(m => m.default || m)
  },
  {
    name: collapsibletoh2r9EGLUMeta?.name ?? "component-collapsible___lv",
    path: collapsibletoh2r9EGLUMeta?.path ?? "/lv/component/collapsible",
    meta: collapsibletoh2r9EGLUMeta || {},
    alias: collapsibletoh2r9EGLUMeta?.alias || [],
    redirect: collapsibletoh2r9EGLUMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/collapsible.vue").then(m => m.default || m)
  },
  {
    name: collapsibletoh2r9EGLUMeta?.name ?? "component-collapsible___lt",
    path: collapsibletoh2r9EGLUMeta?.path ?? "/lt/component/collapsible",
    meta: collapsibletoh2r9EGLUMeta || {},
    alias: collapsibletoh2r9EGLUMeta?.alias || [],
    redirect: collapsibletoh2r9EGLUMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/collapsible.vue").then(m => m.default || m)
  },
  {
    name: collapsibletoh2r9EGLUMeta?.name ?? "component-collapsible___de",
    path: collapsibletoh2r9EGLUMeta?.path ?? "/de/component/collapsible",
    meta: collapsibletoh2r9EGLUMeta || {},
    alias: collapsibletoh2r9EGLUMeta?.alias || [],
    redirect: collapsibletoh2r9EGLUMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/collapsible.vue").then(m => m.default || m)
  },
  {
    name: collapsibletoh2r9EGLUMeta?.name ?? "component-collapsible___et",
    path: collapsibletoh2r9EGLUMeta?.path ?? "/et/component/collapsible",
    meta: collapsibletoh2r9EGLUMeta || {},
    alias: collapsibletoh2r9EGLUMeta?.alias || [],
    redirect: collapsibletoh2r9EGLUMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/collapsible.vue").then(m => m.default || m)
  },
  {
    name: collapsibletoh2r9EGLUMeta?.name ?? "component-collapsible___fi",
    path: collapsibletoh2r9EGLUMeta?.path ?? "/fi/component/collapsible",
    meta: collapsibletoh2r9EGLUMeta || {},
    alias: collapsibletoh2r9EGLUMeta?.alias || [],
    redirect: collapsibletoh2r9EGLUMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/collapsible.vue").then(m => m.default || m)
  },
  {
    name: collapsibletoh2r9EGLUMeta?.name ?? "component-collapsible___ru",
    path: collapsibletoh2r9EGLUMeta?.path ?? "/ru/component/collapsible",
    meta: collapsibletoh2r9EGLUMeta || {},
    alias: collapsibletoh2r9EGLUMeta?.alias || [],
    redirect: collapsibletoh2r9EGLUMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/collapsible.vue").then(m => m.default || m)
  },
  {
    name: collapsibletoh2r9EGLUMeta?.name ?? "component-collapsible___uk",
    path: collapsibletoh2r9EGLUMeta?.path ?? "/uk/component/collapsible",
    meta: collapsibletoh2r9EGLUMeta || {},
    alias: collapsibletoh2r9EGLUMeta?.alias || [],
    redirect: collapsibletoh2r9EGLUMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/collapsible.vue").then(m => m.default || m)
  },
  {
    name: drawerYwRx9qS9UcMeta?.name ?? "component-drawer___en",
    path: drawerYwRx9qS9UcMeta?.path ?? "/en/component/drawer",
    meta: drawerYwRx9qS9UcMeta || {},
    alias: drawerYwRx9qS9UcMeta?.alias || [],
    redirect: drawerYwRx9qS9UcMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/drawer.vue").then(m => m.default || m)
  },
  {
    name: drawerYwRx9qS9UcMeta?.name ?? "component-drawer___lv",
    path: drawerYwRx9qS9UcMeta?.path ?? "/lv/component/drawer",
    meta: drawerYwRx9qS9UcMeta || {},
    alias: drawerYwRx9qS9UcMeta?.alias || [],
    redirect: drawerYwRx9qS9UcMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/drawer.vue").then(m => m.default || m)
  },
  {
    name: drawerYwRx9qS9UcMeta?.name ?? "component-drawer___lt",
    path: drawerYwRx9qS9UcMeta?.path ?? "/lt/component/drawer",
    meta: drawerYwRx9qS9UcMeta || {},
    alias: drawerYwRx9qS9UcMeta?.alias || [],
    redirect: drawerYwRx9qS9UcMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/drawer.vue").then(m => m.default || m)
  },
  {
    name: drawerYwRx9qS9UcMeta?.name ?? "component-drawer___de",
    path: drawerYwRx9qS9UcMeta?.path ?? "/de/component/drawer",
    meta: drawerYwRx9qS9UcMeta || {},
    alias: drawerYwRx9qS9UcMeta?.alias || [],
    redirect: drawerYwRx9qS9UcMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/drawer.vue").then(m => m.default || m)
  },
  {
    name: drawerYwRx9qS9UcMeta?.name ?? "component-drawer___et",
    path: drawerYwRx9qS9UcMeta?.path ?? "/et/component/drawer",
    meta: drawerYwRx9qS9UcMeta || {},
    alias: drawerYwRx9qS9UcMeta?.alias || [],
    redirect: drawerYwRx9qS9UcMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/drawer.vue").then(m => m.default || m)
  },
  {
    name: drawerYwRx9qS9UcMeta?.name ?? "component-drawer___fi",
    path: drawerYwRx9qS9UcMeta?.path ?? "/fi/component/drawer",
    meta: drawerYwRx9qS9UcMeta || {},
    alias: drawerYwRx9qS9UcMeta?.alias || [],
    redirect: drawerYwRx9qS9UcMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/drawer.vue").then(m => m.default || m)
  },
  {
    name: drawerYwRx9qS9UcMeta?.name ?? "component-drawer___ru",
    path: drawerYwRx9qS9UcMeta?.path ?? "/ru/component/drawer",
    meta: drawerYwRx9qS9UcMeta || {},
    alias: drawerYwRx9qS9UcMeta?.alias || [],
    redirect: drawerYwRx9qS9UcMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/drawer.vue").then(m => m.default || m)
  },
  {
    name: drawerYwRx9qS9UcMeta?.name ?? "component-drawer___uk",
    path: drawerYwRx9qS9UcMeta?.path ?? "/uk/component/drawer",
    meta: drawerYwRx9qS9UcMeta || {},
    alias: drawerYwRx9qS9UcMeta?.alias || [],
    redirect: drawerYwRx9qS9UcMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/drawer.vue").then(m => m.default || m)
  },
  {
    name: input_45baseuPwDfNVod9Meta?.name ?? "component-input-base___en",
    path: input_45baseuPwDfNVod9Meta?.path ?? "/en/component/input-base",
    meta: input_45baseuPwDfNVod9Meta || {},
    alias: input_45baseuPwDfNVod9Meta?.alias || [],
    redirect: input_45baseuPwDfNVod9Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/input-base.vue").then(m => m.default || m)
  },
  {
    name: input_45baseuPwDfNVod9Meta?.name ?? "component-input-base___lv",
    path: input_45baseuPwDfNVod9Meta?.path ?? "/lv/component/input-base",
    meta: input_45baseuPwDfNVod9Meta || {},
    alias: input_45baseuPwDfNVod9Meta?.alias || [],
    redirect: input_45baseuPwDfNVod9Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/input-base.vue").then(m => m.default || m)
  },
  {
    name: input_45baseuPwDfNVod9Meta?.name ?? "component-input-base___lt",
    path: input_45baseuPwDfNVod9Meta?.path ?? "/lt/component/input-base",
    meta: input_45baseuPwDfNVod9Meta || {},
    alias: input_45baseuPwDfNVod9Meta?.alias || [],
    redirect: input_45baseuPwDfNVod9Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/input-base.vue").then(m => m.default || m)
  },
  {
    name: input_45baseuPwDfNVod9Meta?.name ?? "component-input-base___de",
    path: input_45baseuPwDfNVod9Meta?.path ?? "/de/component/input-base",
    meta: input_45baseuPwDfNVod9Meta || {},
    alias: input_45baseuPwDfNVod9Meta?.alias || [],
    redirect: input_45baseuPwDfNVod9Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/input-base.vue").then(m => m.default || m)
  },
  {
    name: input_45baseuPwDfNVod9Meta?.name ?? "component-input-base___et",
    path: input_45baseuPwDfNVod9Meta?.path ?? "/et/component/input-base",
    meta: input_45baseuPwDfNVod9Meta || {},
    alias: input_45baseuPwDfNVod9Meta?.alias || [],
    redirect: input_45baseuPwDfNVod9Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/input-base.vue").then(m => m.default || m)
  },
  {
    name: input_45baseuPwDfNVod9Meta?.name ?? "component-input-base___fi",
    path: input_45baseuPwDfNVod9Meta?.path ?? "/fi/component/input-base",
    meta: input_45baseuPwDfNVod9Meta || {},
    alias: input_45baseuPwDfNVod9Meta?.alias || [],
    redirect: input_45baseuPwDfNVod9Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/input-base.vue").then(m => m.default || m)
  },
  {
    name: input_45baseuPwDfNVod9Meta?.name ?? "component-input-base___ru",
    path: input_45baseuPwDfNVod9Meta?.path ?? "/ru/component/input-base",
    meta: input_45baseuPwDfNVod9Meta || {},
    alias: input_45baseuPwDfNVod9Meta?.alias || [],
    redirect: input_45baseuPwDfNVod9Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/input-base.vue").then(m => m.default || m)
  },
  {
    name: input_45baseuPwDfNVod9Meta?.name ?? "component-input-base___uk",
    path: input_45baseuPwDfNVod9Meta?.path ?? "/uk/component/input-base",
    meta: input_45baseuPwDfNVod9Meta || {},
    alias: input_45baseuPwDfNVod9Meta?.alias || [],
    redirect: input_45baseuPwDfNVod9Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/input-base.vue").then(m => m.default || m)
  },
  {
    name: input_45inlineYNJqqFaB84Meta?.name ?? "component-input-inline___en",
    path: input_45inlineYNJqqFaB84Meta?.path ?? "/en/component/input-inline",
    meta: input_45inlineYNJqqFaB84Meta || {},
    alias: input_45inlineYNJqqFaB84Meta?.alias || [],
    redirect: input_45inlineYNJqqFaB84Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/input-inline.vue").then(m => m.default || m)
  },
  {
    name: input_45inlineYNJqqFaB84Meta?.name ?? "component-input-inline___lv",
    path: input_45inlineYNJqqFaB84Meta?.path ?? "/lv/component/input-inline",
    meta: input_45inlineYNJqqFaB84Meta || {},
    alias: input_45inlineYNJqqFaB84Meta?.alias || [],
    redirect: input_45inlineYNJqqFaB84Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/input-inline.vue").then(m => m.default || m)
  },
  {
    name: input_45inlineYNJqqFaB84Meta?.name ?? "component-input-inline___lt",
    path: input_45inlineYNJqqFaB84Meta?.path ?? "/lt/component/input-inline",
    meta: input_45inlineYNJqqFaB84Meta || {},
    alias: input_45inlineYNJqqFaB84Meta?.alias || [],
    redirect: input_45inlineYNJqqFaB84Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/input-inline.vue").then(m => m.default || m)
  },
  {
    name: input_45inlineYNJqqFaB84Meta?.name ?? "component-input-inline___de",
    path: input_45inlineYNJqqFaB84Meta?.path ?? "/de/component/input-inline",
    meta: input_45inlineYNJqqFaB84Meta || {},
    alias: input_45inlineYNJqqFaB84Meta?.alias || [],
    redirect: input_45inlineYNJqqFaB84Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/input-inline.vue").then(m => m.default || m)
  },
  {
    name: input_45inlineYNJqqFaB84Meta?.name ?? "component-input-inline___et",
    path: input_45inlineYNJqqFaB84Meta?.path ?? "/et/component/input-inline",
    meta: input_45inlineYNJqqFaB84Meta || {},
    alias: input_45inlineYNJqqFaB84Meta?.alias || [],
    redirect: input_45inlineYNJqqFaB84Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/input-inline.vue").then(m => m.default || m)
  },
  {
    name: input_45inlineYNJqqFaB84Meta?.name ?? "component-input-inline___fi",
    path: input_45inlineYNJqqFaB84Meta?.path ?? "/fi/component/input-inline",
    meta: input_45inlineYNJqqFaB84Meta || {},
    alias: input_45inlineYNJqqFaB84Meta?.alias || [],
    redirect: input_45inlineYNJqqFaB84Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/input-inline.vue").then(m => m.default || m)
  },
  {
    name: input_45inlineYNJqqFaB84Meta?.name ?? "component-input-inline___ru",
    path: input_45inlineYNJqqFaB84Meta?.path ?? "/ru/component/input-inline",
    meta: input_45inlineYNJqqFaB84Meta || {},
    alias: input_45inlineYNJqqFaB84Meta?.alias || [],
    redirect: input_45inlineYNJqqFaB84Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/input-inline.vue").then(m => m.default || m)
  },
  {
    name: input_45inlineYNJqqFaB84Meta?.name ?? "component-input-inline___uk",
    path: input_45inlineYNJqqFaB84Meta?.path ?? "/uk/component/input-inline",
    meta: input_45inlineYNJqqFaB84Meta || {},
    alias: input_45inlineYNJqqFaB84Meta?.alias || [],
    redirect: input_45inlineYNJqqFaB84Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/component/input-inline.vue").then(m => m.default || m)
  },
  {
    name: indexTLhFQU3CkjMeta?.name ?? "index___en",
    path: indexTLhFQU3CkjMeta?.path ?? "/en/index",
    meta: indexTLhFQU3CkjMeta || {},
    alias: indexTLhFQU3CkjMeta?.alias || [],
    redirect: indexTLhFQU3CkjMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexTLhFQU3CkjMeta?.name ?? "index___lv",
    path: indexTLhFQU3CkjMeta?.path ?? "/lv/index",
    meta: indexTLhFQU3CkjMeta || {},
    alias: indexTLhFQU3CkjMeta?.alias || [],
    redirect: indexTLhFQU3CkjMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexTLhFQU3CkjMeta?.name ?? "index___lt",
    path: indexTLhFQU3CkjMeta?.path ?? "/lt/index",
    meta: indexTLhFQU3CkjMeta || {},
    alias: indexTLhFQU3CkjMeta?.alias || [],
    redirect: indexTLhFQU3CkjMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexTLhFQU3CkjMeta?.name ?? "index___de",
    path: indexTLhFQU3CkjMeta?.path ?? "/de/index",
    meta: indexTLhFQU3CkjMeta || {},
    alias: indexTLhFQU3CkjMeta?.alias || [],
    redirect: indexTLhFQU3CkjMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexTLhFQU3CkjMeta?.name ?? "index___et",
    path: indexTLhFQU3CkjMeta?.path ?? "/et/index",
    meta: indexTLhFQU3CkjMeta || {},
    alias: indexTLhFQU3CkjMeta?.alias || [],
    redirect: indexTLhFQU3CkjMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexTLhFQU3CkjMeta?.name ?? "index___fi",
    path: indexTLhFQU3CkjMeta?.path ?? "/fi/index",
    meta: indexTLhFQU3CkjMeta || {},
    alias: indexTLhFQU3CkjMeta?.alias || [],
    redirect: indexTLhFQU3CkjMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexTLhFQU3CkjMeta?.name ?? "index___ru",
    path: indexTLhFQU3CkjMeta?.path ?? "/ru/index",
    meta: indexTLhFQU3CkjMeta || {},
    alias: indexTLhFQU3CkjMeta?.alias || [],
    redirect: indexTLhFQU3CkjMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexTLhFQU3CkjMeta?.name ?? "index___uk",
    path: indexTLhFQU3CkjMeta?.path ?? "/uk/index",
    meta: indexTLhFQU3CkjMeta || {},
    alias: indexTLhFQU3CkjMeta?.alias || [],
    redirect: indexTLhFQU3CkjMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: manage_45my_45bookingcBDqHirJEvMeta?.name ?? "manage-my-booking___en",
    path: manage_45my_45bookingcBDqHirJEvMeta?.path ?? "/en/manage-my-booking",
    meta: manage_45my_45bookingcBDqHirJEvMeta || {},
    alias: manage_45my_45bookingcBDqHirJEvMeta?.alias || [],
    redirect: manage_45my_45bookingcBDqHirJEvMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/manage-my-booking.vue").then(m => m.default || m)
  },
  {
    name: manage_45my_45bookingcBDqHirJEvMeta?.name ?? "manage-my-booking___lv",
    path: manage_45my_45bookingcBDqHirJEvMeta?.path ?? "/lv/mana-rezervacija",
    meta: manage_45my_45bookingcBDqHirJEvMeta || {},
    alias: manage_45my_45bookingcBDqHirJEvMeta?.alias || [],
    redirect: manage_45my_45bookingcBDqHirJEvMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/manage-my-booking.vue").then(m => m.default || m)
  },
  {
    name: manage_45my_45bookingcBDqHirJEvMeta?.name ?? "manage-my-booking___lt",
    path: manage_45my_45bookingcBDqHirJEvMeta?.path ?? "/lt/mano-uzsakymai",
    meta: manage_45my_45bookingcBDqHirJEvMeta || {},
    alias: manage_45my_45bookingcBDqHirJEvMeta?.alias || [],
    redirect: manage_45my_45bookingcBDqHirJEvMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/manage-my-booking.vue").then(m => m.default || m)
  },
  {
    name: manage_45my_45bookingcBDqHirJEvMeta?.name ?? "manage-my-booking___de",
    path: manage_45my_45bookingcBDqHirJEvMeta?.path ?? "/de/buchung-verwalten",
    meta: manage_45my_45bookingcBDqHirJEvMeta || {},
    alias: manage_45my_45bookingcBDqHirJEvMeta?.alias || [],
    redirect: manage_45my_45bookingcBDqHirJEvMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/manage-my-booking.vue").then(m => m.default || m)
  },
  {
    name: manage_45my_45bookingcBDqHirJEvMeta?.name ?? "manage-my-booking___et",
    path: manage_45my_45bookingcBDqHirJEvMeta?.path ?? "/et/halda-broneeringut",
    meta: manage_45my_45bookingcBDqHirJEvMeta || {},
    alias: manage_45my_45bookingcBDqHirJEvMeta?.alias || [],
    redirect: manage_45my_45bookingcBDqHirJEvMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/manage-my-booking.vue").then(m => m.default || m)
  },
  {
    name: manage_45my_45bookingcBDqHirJEvMeta?.name ?? "manage-my-booking___fi",
    path: manage_45my_45bookingcBDqHirJEvMeta?.path ?? "/fi/hallitse-varausta",
    meta: manage_45my_45bookingcBDqHirJEvMeta || {},
    alias: manage_45my_45bookingcBDqHirJEvMeta?.alias || [],
    redirect: manage_45my_45bookingcBDqHirJEvMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/manage-my-booking.vue").then(m => m.default || m)
  },
  {
    name: manage_45my_45bookingcBDqHirJEvMeta?.name ?? "manage-my-booking___ru",
    path: manage_45my_45bookingcBDqHirJEvMeta?.path ?? "/ru/upravlenie-bronirovaniem",
    meta: manage_45my_45bookingcBDqHirJEvMeta || {},
    alias: manage_45my_45bookingcBDqHirJEvMeta?.alias || [],
    redirect: manage_45my_45bookingcBDqHirJEvMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/manage-my-booking.vue").then(m => m.default || m)
  },
  {
    name: manage_45my_45bookingcBDqHirJEvMeta?.name ?? "manage-my-booking___uk",
    path: manage_45my_45bookingcBDqHirJEvMeta?.path ?? "/uk/keruvaty-bronyuvannyam",
    meta: manage_45my_45bookingcBDqHirJEvMeta || {},
    alias: manage_45my_45bookingcBDqHirJEvMeta?.alias || [],
    redirect: manage_45my_45bookingcBDqHirJEvMeta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/manage-my-booking.vue").then(m => m.default || m)
  },
  {
    name: self_45service_45portalEMseZcIYq0Meta?.name ?? "self-service-portal___en",
    path: self_45service_45portalEMseZcIYq0Meta?.path ?? "/en/self-service-portal",
    meta: self_45service_45portalEMseZcIYq0Meta || {},
    alias: self_45service_45portalEMseZcIYq0Meta?.alias || [],
    redirect: self_45service_45portalEMseZcIYq0Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/self-service-portal.vue").then(m => m.default || m)
  },
  {
    name: self_45service_45portalEMseZcIYq0Meta?.name ?? "self-service-portal___lv",
    path: self_45service_45portalEMseZcIYq0Meta?.path ?? "/lv/self-service-portal",
    meta: self_45service_45portalEMseZcIYq0Meta || {},
    alias: self_45service_45portalEMseZcIYq0Meta?.alias || [],
    redirect: self_45service_45portalEMseZcIYq0Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/self-service-portal.vue").then(m => m.default || m)
  },
  {
    name: self_45service_45portalEMseZcIYq0Meta?.name ?? "self-service-portal___lt",
    path: self_45service_45portalEMseZcIYq0Meta?.path ?? "/lt/self-service-portal",
    meta: self_45service_45portalEMseZcIYq0Meta || {},
    alias: self_45service_45portalEMseZcIYq0Meta?.alias || [],
    redirect: self_45service_45portalEMseZcIYq0Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/self-service-portal.vue").then(m => m.default || m)
  },
  {
    name: self_45service_45portalEMseZcIYq0Meta?.name ?? "self-service-portal___de",
    path: self_45service_45portalEMseZcIYq0Meta?.path ?? "/de/self-service-portal",
    meta: self_45service_45portalEMseZcIYq0Meta || {},
    alias: self_45service_45portalEMseZcIYq0Meta?.alias || [],
    redirect: self_45service_45portalEMseZcIYq0Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/self-service-portal.vue").then(m => m.default || m)
  },
  {
    name: self_45service_45portalEMseZcIYq0Meta?.name ?? "self-service-portal___et",
    path: self_45service_45portalEMseZcIYq0Meta?.path ?? "/et/self-service-portal",
    meta: self_45service_45portalEMseZcIYq0Meta || {},
    alias: self_45service_45portalEMseZcIYq0Meta?.alias || [],
    redirect: self_45service_45portalEMseZcIYq0Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/self-service-portal.vue").then(m => m.default || m)
  },
  {
    name: self_45service_45portalEMseZcIYq0Meta?.name ?? "self-service-portal___fi",
    path: self_45service_45portalEMseZcIYq0Meta?.path ?? "/fi/self-service-portal",
    meta: self_45service_45portalEMseZcIYq0Meta || {},
    alias: self_45service_45portalEMseZcIYq0Meta?.alias || [],
    redirect: self_45service_45portalEMseZcIYq0Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/self-service-portal.vue").then(m => m.default || m)
  },
  {
    name: self_45service_45portalEMseZcIYq0Meta?.name ?? "self-service-portal___ru",
    path: self_45service_45portalEMseZcIYq0Meta?.path ?? "/ru/self-service-portal",
    meta: self_45service_45portalEMseZcIYq0Meta || {},
    alias: self_45service_45portalEMseZcIYq0Meta?.alias || [],
    redirect: self_45service_45portalEMseZcIYq0Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/self-service-portal.vue").then(m => m.default || m)
  },
  {
    name: self_45service_45portalEMseZcIYq0Meta?.name ?? "self-service-portal___uk",
    path: self_45service_45portalEMseZcIYq0Meta?.path ?? "/uk/self-service-portal",
    meta: self_45service_45portalEMseZcIYq0Meta || {},
    alias: self_45service_45portalEMseZcIYq0Meta?.alias || [],
    redirect: self_45service_45portalEMseZcIYq0Meta?.redirect,
    component: () => import("/builds/common/airbaltic-com/bt-frontend-nuxt/pages/self-service-portal.vue").then(m => m.default || m)
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/en",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/lv",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/de",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/et",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/fi",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/lt",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/ru",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/uk",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/index-sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/en-sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/lv-sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/lt-sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/de-sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/et-sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/fi-sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/ru-sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  },
  {
    name: component_45stubRZ7YypkiNzMeta?.name ?? undefined,
    path: component_45stubRZ7YypkiNzMeta?.path ?? "/uk-sitemap.xml",
    meta: component_45stubRZ7YypkiNzMeta || {},
    alias: component_45stubRZ7YypkiNzMeta?.alias || [],
    redirect: component_45stubRZ7YypkiNzMeta?.redirect,
    component: component_45stubRZ7YypkiNz
  }
]